interface Props {
  [key: string]: any
}
function PhoneThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M0.980225 2.96586C0.980225 2.43898 1.18953 1.93368 1.56209 1.56111C1.93465 1.18855 2.43996 0.979248 2.96684 0.979248H6.22488C6.43327 0.979406 6.63633 1.0451 6.80533 1.16703C6.97432 1.28896 7.10069 1.46096 7.16654 1.65867L8.65451 6.1216C8.72991 6.34841 8.72099 6.5948 8.6294 6.81556C8.53781 7.03633 8.36968 7.21667 8.15587 7.3235L5.91398 8.44593C7.01289 10.8781 8.96091 12.8261 11.3931 13.925L12.5155 11.6831C12.6223 11.4693 12.8027 11.3012 13.0234 11.2096C13.2442 11.118 13.4906 11.1091 13.7174 11.1845L18.1803 12.6725C18.3782 12.7384 18.5503 12.8649 18.6722 13.0341C18.7942 13.2033 18.8598 13.4065 18.8597 13.6151V16.8722C18.8597 17.399 18.6504 17.9043 18.2779 18.2769C17.9053 18.6495 17.4 18.8588 16.8731 18.8588H15.8798C7.65127 18.8588 0.980225 12.1877 0.980225 3.95917V2.96586Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PhoneThinIcon
